import { defineMessages } from 'react-intl';

export default defineMessages({
1:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.#',
defaultMessage: '#'
},
datOfVio2:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Date of Violation',
defaultMessage: 'Date of Violation'
},
vioCat3:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Violation Category',
defaultMessage: 'Violation Category'
},
des4:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Description',
defaultMessage: 'Description'
},
ifOth5:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.If Other',
defaultMessage: 'If Other'
},
typ6:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Type',
defaultMessage: 'Type'
},
removeViolation:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Remove Violation',
defaultMessage: 'Remove Violation {vioDesc}'
},
removedViolation:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Removed Violation',
defaultMessage: 'Removed Violation {vioDesc} dated {vioDate}'
},
addViolation:{
id: 'quoteandbind.PPLProLinedirectives.templates.MovingTrafficViolations.Add Moving Traffic Violation',
defaultMessage: 'Add Moving Traffic Violation'
}
});